<app-loader  [is_show_loader]="true" ></app-loader>